import React, { useState, useEffect } from 'react';
import _find from 'lodash/find';
import IconBack from 'cccisd-icons/arrow-left6';
import { LoginForm } from 'cccisd-laravel-nexus';
import Loader from 'cccisd-loader';
import { Link } from 'cccisd-react-router';
import Style from './style.css';

const Env = window.cccisd.env;
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;

export const CV_URL = Env?.cvUrl || 'https://app.centervention.com';

const Welcome = () => {
    const [isAdminLogin, setIsAdminLogin] = useState(false);
    const [redirectTimer, setRedirectTimer] = useState(10);

    useEffect(() => {
        const x = setInterval(() => setRedirectTimer(p => p - 1), 1000);
        return () => clearInterval(x);
    }, []);

    let homepageRoute;
    try {
        homepageRoute = _find(AppDefs.routes, r => r.handle === AppDefs.navs[0].homepage);
    } catch (e) {
        // meh
    }

    if (Fortress.auth()) {
        return (
            <div className={`mt-5 text-center ${Style.welcomeBox}`}>
                <p className="mb-3">Hello, {Fortress.user.username}</p>
                {homepageRoute && (
                    <Link to={homepageRoute.url}>
                        <button type="button" className="btn btn-primary">
                            Go To Home
                        </button>
                    </Link>
                )}
            </div>
        );
    }

    if (isAdminLogin) {
        return (
            <div className="row mt-4">
                <div className="col-md-8">
                    <h1>Welcome to SHARE</h1>
                    <a href={CV_URL}>
                        <IconBack spaceRight />
                        Return to Centervention
                    </a>
                </div>
                <div className="col-md-4">
                    <LoginForm showPasswordToggle />
                </div>
            </div>
        );
    }

    if (redirectTimer <= 0) {
        window.location = CV_URL;
        return <Loader loading type="inline" />;
    }

    return (
        <div className={`mt-5 ${Style.welcomeBox} ${Style.redirectBox}`}>
            <h1 className="text-primary">Welcome to SHARE</h1>
            <p className="mb-5">
                Redirecting to{' '}
                <a href={CV_URL} className={`link-underline link-underline-opacity-50 link-offset-2 ${Style.cvLink}`}>
                    Centervention
                </a>{' '}
                in {redirectTimer} seconds...
            </p>
            <div className="text-end">
                <a
                    className={`link-underline link-underline-opacity-50 link-offset-2 ${Style.cvLink}`}
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                        setIsAdminLogin(true);
                    }}
                >
                    Admin Login
                </a>
            </div>
        </div>
    );
};

export default Welcome;
